export default __webpack_public_path__ + "static/media/potato-19.3b30ba1b.png";